var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRailpass1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coupon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456,128.8008H175.4922a7.9979,7.9979,0,0,0-8,8,11.8672,11.8672,0,0,1-23.7344,0,7.9979,7.9979,0,0,0-8-8H56a7.9979,7.9979,0,0,0-8,8V375.1992a7.9979,7.9979,0,0,0,8,8h79.7578a7.9979,7.9979,0,0,0,8-8,11.8672,11.8672,0,1,1,23.7344,0,7.9979,7.9979,0,0,0,8,8H456a7.9979,7.9979,0,0,0,8-8V136.8008A7.9979,7.9979,0,0,0,456,128.8008Zm-8,238.3984H182.32a27.8687,27.8687,0,0,0-53.3906,0H64V144.8008h64.93a27.8687,27.8687,0,0,0,53.3906,0H448Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.9063,249.6133a28.8036,28.8036,0,0,0,20.375-49.1719h-.004c-10.8906-10.8906-29.871-10.8906-40.746,0a28.7969,28.7969,0,0,0,20.375,49.1719Zm-9.0586-37.8594a12.7925,12.7925,0,0,1,18.1132,0h.0039a12.8165,12.8165,0,1,1-18.1171,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.6523,270.8164c-10.8828-10.8906-29.8632-10.8906-40.746,0a28.8125,28.8125,0,1,0,40.75,0Zm-11.3125,29.43a13.1152,13.1152,0,0,1-18.121,0,12.8145,12.8145,0,1,1,18.121,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.0352,312.0586a7.9972,7.9972,0,0,0,11.3125,0L363.1484,211.2539a7.9991,7.9991,0,0,0-11.3125-11.3125L251.0352,300.7461A7.9971,7.9971,0,0,0,251.0352,312.0586Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.625,182.02a7.9979,7.9979,0,0,0-8,8v18.4453a8,8,0,0,0,16,0V190.02A7.9979,7.9979,0,0,0,155.625,182.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.625,238.7773a7.9979,7.9979,0,0,0-8,8v18.4454a8,8,0,0,0,16,0V246.7773A7.9979,7.9979,0,0,0,155.625,238.7773Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.625,295.5352a7.9979,7.9979,0,0,0-8,8v18.4531a8,8,0,0,0,16,0V303.5352A7.9979,7.9979,0,0,0,155.625,295.5352Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailpass1);
export default __webpack_public_path__ + "static/media/railpass-1.1fcc03d6a8e99c682a31a82dba44e2cf.svg";
export { ForwardRef as ReactComponent };